import { useFragment } from '@apollo/client/react';
import { PageLoader } from '@optools/components/loading/page-loader';
import { gamePkSchema } from '@optools/schemas/game';
import { BTC_GAME_FRAGMENT } from '@optools/services/operator-gateway/btc/fragments';
import { GameDetailBreadcrumbs } from '@optools/tools/btc-tools/components/game-detail/game-detail-breadcrumbs';
import { GameDetailNavigation } from '@optools/tools/btc-tools/components/game-detail/game-detail-navigation';
import { QuickSwitch } from '@optools/tools/btc-tools/components/game-detail/quick-switch';
import { useBtcScheduleContext } from '@optools/tools/btc-tools/context/btc-schedule-context';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

/* eslint-disable perfectionist/sort-objects */
export const Route = createFileRoute('/_auth/btc-tools/schedule/$gamePk')({
  component: RouteComponent,
  params: { parse: zodValidator(gamePkSchema).parse },
  beforeLoad: authorizedRouteLoader('btcTools.schedule.game'),
});
/* eslint-enable perfectionist/sort-objects */

export function RouteComponent() {
  const { date } = useSearch({ from: '/_auth/btc-tools/schedule' });
  const { gamePk } = useParams({ from: '/_auth/btc-tools/schedule/$gamePk' });

  const { loading, schedule } = useBtcScheduleContext();

  const gameFragment = useFragment({
    fragment: BTC_GAME_FRAGMENT,
    fragmentName: 'BTCGameFields',
    from: { __typename: 'Game', gamePk },
  });

  if (loading) return <PageLoader />;

  if (!gameFragment.complete) {
    return (
      <div className="flex justify-center">
        <h1 className="text-lg font-bold">Could not find game with GamePK: {gamePk}</h1>
      </div>
    );
  }

  return (
    <div className="grid h-full grid-rows-[auto_1fr] gap-4">
      <GameDetailBreadcrumbs date={date} gamePk={gamePk} />

      <div className="-ml-2 grid gap-6 overflow-y-auto pl-2 lg:h-full lg:grid-cols-[--spacing(64)_1fr] lg:overflow-y-hidden">
        <QuickSwitch date={date} gamePk={gamePk} games={schedule} />
        <GameDetailNavigation date={date} gamePk={gamePk} />
      </div>
    </div>
  );
}
